<template>
	<div>
		<v-text-field
				solo
				flat
				clearable
				label="Search for your question"
				v-if="nosearch !== true"
				:value="query"
				class="question-search"
				@input="setQuery"
		></v-text-field>

		<v-container v-if="filtered_answers.length">
			<article v-for="answer in filtered_answers" class="answer">
				<div class="answer-head">
					<div>
						<h1 id="answer-head-question">{{answer.question}}</h1>
					</div>
					<div>
						<h2 v-if="answer.category.length" id="answer-head-category">{{answer.category}}</h2>
					</div>
				</div>

				<p v-html="answer.answer"></p>
			</article>
		</v-container>
	</div>
</template>

<script>
	import Axios from 'axios';
	import _ from 'lodash';

	export default {
		name: "QuestionSearch",
		props: {
			nosearch: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				answers: [],
				query: '',
				loading: false
			}
		},
		mounted() {
			this.fetchAnswers();
		},
		computed: {
			filtered_answers() {
				if (this.query.length <= 2) return [];
				let result = _.filter(this.answers, (answer) => {
					return _.lowerCase(answer.question).indexOf((_.lowerCase(this.query))) >= 0;
				});
				if (result.length <= 0) {
					result = [{
						question: 'Sorry, nothing found',
						category: '',
						answer: '',
					}];
				}
				return result
			},
		},
		methods: {
			setQuery: _.debounce(function (value) {
				this.query = _.trim(value);
			}, 300),

			fetchAnswers() {
				self.loading = true;

				Axios.get('/service/customer_help/rest/index.php/customer_help/get_questions')
					.then(({status, data}) => {
						if (status === 200 && data) {
							this.answers = data;
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		}
	}
</script>

<style scoped>
	.answer {
		border-top: 2px solid #2884e0;
	}

	.answer-head {
		display: flex;
		justify-content: space-between;
	}

	#answer-head-question {
		margin: 0 15px 0 0;
		text-align: left;
	}

	#answer-head-category {
		padding: 5px;
		background-color: #2884e0;
		color: #fff;
		font-size: 10pt;
		margin-left: 10px !important;
	}
</style>